import styled, { css } from 'styled-components';

// Scoped values from the v6 prototypes. Keep the app-wide styleguide intact.
export const examsTokens = css`
  --ex-purple: var(--light-mode-purple);
  --ex-royal: var(--royal-purple);
  --ex-ink: var(--dark-purple);
  --ex-ink-2: #56515f;
  --ex-ink-strong: #4a4458;
  --ex-ink-muted: #6c6875;
  --ex-ink-faint: #b9b5c0;
  --ex-disabled-bg: #d9d6de;
  --ex-line: #eceaf1;
  --ex-line-strong: #d6d3dc;
  --ex-surface: var(--white);
  --ex-surface-tint: var(--white-pointer);
  --ex-surface-2: #f7f6fa;
  --ex-panel-tint: #fbfafd;
  --ex-preview-bg: #eeecf2;
  --ex-selected-tint: #fbf8fe;
  --ex-plan-tint: #f7f1ff;
  --ex-purple-100: var(--blue-chalk-2);
  --ex-purple-150: var(--blue-chalk);
  --ex-purple-200: var(--fog);
  --ex-purple-strong: #9b5cf6;
  --ex-ok-ink: #1f6440;
  --ex-ok-bg: #e3f5ec;
  --ex-ok: #2eb67d;
  --ex-ok-action: #1f7a50;
  --ex-bad-ink: #b3261e;
  --ex-loose-ink: #8f1d16;
  --ex-bad-bg: #fde2e2;
  --ex-bad: #e0301e;
  --ex-warn-ink: var(--horses-neck);
  --ex-warn-bg: var(--wheatfield);
  --ex-warn: #e6b800;
  --ex-warn-strong: #a07c00;
  --ex-info-ink: var(--congress-blue);
  --ex-info-bg: var(--hawkes-blue);
  --ex-grade-d-ink: #b35a12;
  --ex-grade-d-bg: #fde9d9;
  --ex-grade-b-ink: #2f6fd6;
  --ex-grade-b-bg: #e6effc;
  --ex-shadow-1: 0 2px 10px rgba(48, 27, 114, 0.06);
  --ex-shadow-2: 0 6px 24px rgba(48, 27, 114, 0.15);
  --ex-shadow-3: 0 12px 32px rgba(48, 27, 114, 0.18);
  --ex-shadow-accent: 0 4px 16px rgba(114, 0, 224, 0.2);
  --ex-shadow-modal: 0 20px 50px rgba(0, 0, 0, 0.25);
  --ex-scrim: rgba(37, 34, 42, 0.45);
  --ex-font-size-xs: 12px;
  --ex-font-family: 'IBM Plex Sans', system-ui, Helvetica, Arial, sans-serif;
  --ex-radius-pill: 30px;
  --ex-radius-card: 12px;
  --ex-radius-item: 8px;
`;

/**
 * Wraps an Exams tree (or a portal's content) in the Exams tokens. The app
 * body sets line-height: 1; the prototypes use the browser's `normal`.
 */
export const ExamsScope = styled.div`
  ${examsTokens}
  color: var(--ex-ink);
  font-family: var(--ex-font-family);
  line-height: normal;
`;
